import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Moment from 'moment'

import Styles from './index.scss'

const Item = props => (
  <tr>
    <td> {parseInt(props.skip, 0) + props.indexKey + 1} </td>
    <td>
      <div className={Styles.containerActions}>
        <Link
          to={`/projects/${props.row.id}`}
          className={`btn btn-icon-only red ${Styles.linkDetail}`}
        >
          <i className="fa fa-eye" />
        </Link>
        <button
          className={Styles.btnViewMarketplace}
          onClick={props.goesTopPlatform(
            props.row.profile.profileId,
            props.userEmail,
            `project/${props.row.id}/order`,
            'project'
          )}
        >
          View as Super User
        </button>
      </div>
    </td>
    <td> {Moment(`${props.row.updatedAt}`).format('MMMM, DD YYYY')} </td>
    <td> {Moment(`${props.row.createdAt}`).format('MMMM, DD YYYY')} </td>
    <td>
      <span>{props.row.name} </span>
    </td>
    <td style={{ whiteSpace: 'nowrap' }}>
      {props.row.isManaged ? (
        <span>
          {props.row.orderManagers.map(manager => (
            <div key={manager.id}>{` - ${manager.user.email}`}</div>
          ))}
        </span>
      ) : (
        '-'
      )}
    </td>
    <td>
      <span>{props.row.user.email} </span>
    </td>
    <td>
      <span>
        <a
          href={`/profiles/${props.row.profile.profileId}`}
          rel="noreferrer noopener"
          target="_blank"
        >
          {props.row.profile.profileId}
        </a>
      </span>
    </td>
    <td>
      <span>{props.row.brand} </span>
    </td>
    <td>
      <span>{props.orderStatus[props.row.status]} </span>
    </td>
    <td>
      <span>{props.row.country.name} </span>
    </td>
  </tr>
)

Item.defaultProps = {
  row: {
    id: '',
    updatedAt: '',
    createdAt: '',
    profileId: '',
    name: '',
    status: -1,
  },
  orderStatus: {},
  skip: 0,
  indexKey: 0,
  userEmail: '',
  goesTopPlatform: () => {},
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    profileId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
    status: PropTypes.number,
    country: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    user: PropTypes.shape({
      email: PropTypes.string.isRequired,
    }).isRequired,
    profile: PropTypes.shape({
      profileId: PropTypes.string,
    }).isRequired,
    isManaged: PropTypes.bool,
    orderManagers: PropTypes.arrayOf(PropTypes.shape),
  }).isRequired,
  orderStatus: PropTypes.arrayOf(PropTypes.string).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
  goesTopPlatform: PropTypes.func,
  userEmail: PropTypes.string,
}

export default Item
